//#region src/location_recommendations_level.ts
var LocationRecommendationsLevel = /* @__PURE__ */ function(LocationRecommendationsLevel) {
	LocationRecommendationsLevel[LocationRecommendationsLevel["Off"] = 0] = "Off";
	LocationRecommendationsLevel[LocationRecommendationsLevel["Passive"] = 1] = "Passive";
	LocationRecommendationsLevel[LocationRecommendationsLevel["Active"] = 2] = "Active";
	LocationRecommendationsLevel[LocationRecommendationsLevel["ModsOnly"] = 3] = "ModsOnly";
	return LocationRecommendationsLevel;
}(LocationRecommendationsLevel || {});
//#endregion
export { LocationRecommendationsLevel };

//# sourceMappingURL=location_recommendations_level.js.map